define.alias("shared/helpers/concat-classes", "settings/helpers/concat-classes");